import { render, staticRenderFns } from "./CreateScoreGrade.vue?vue&type=template&id=b18767aa&"
import script from "./CreateScoreGrade.vue?vue&type=script&lang=ts&"
export * from "./CreateScoreGrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports